import { useApiUrl } from '@gemini/lux-ds-pms';
import { OBRoutes } from '@utils/apiRoutes';
import { useOBQuery } from '@hooks/useOBQuery';

export interface InsuranceRequest {
  organizationId: string | undefined;
  patientId?: string | undefined;
  carrierId?: string | undefined;
}
export interface PatientPolicyDTO {
  policyUuid: string;
  memberId: string;
  planId: string;
  insuranceName: string;
  insuranceType: string;
  classification: string;
  insuredPartyContact: InsuredPartyContact;
}

interface InsuredPartyContact {
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  gender: string;
  phoneNumber: PhoneNumber;
  streetAddress: string;
  city: string;
  zipCode: string;
  state: string;
  country: string;
  relationship: string;
}

interface PhoneNumber {
  completePhoneNumber: string;
  prefix: string;
  phoneNumber: string;
  type: string;
}

const useGetPatientPolicies = ({
  organizationId,
  patientId,
  carrierId,
}: InsuranceRequest) => {
  const baseUrl = useApiUrl(
    OBRoutes.PatientPolicies,
    'ONLINEBOOKING_CLIENT_BFF_API_BASE_URL',
  )
    ?.replace('##organizationId', organizationId || '')
    ?.replace('##patientId', patientId || '');

  const normalizedCarrierId = carrierId?.trim();
  const url =
    patientId && normalizedCarrierId
      ? `${baseUrl}?${new URLSearchParams({ carrierUuid: normalizedCarrierId })}`
      : undefined;

  return useOBQuery<PatientPolicyDTO[]>(url, {
    enabled:
      !!url &&
      !!organizationId &&
      !!patientId &&
      !!normalizedCarrierId &&
      carrierId !== '0',
    staleTime: 600000,
  });
};

export default useGetPatientPolicies;
